import type { MainChartData } from '#/modules/salary/types/MainChartData';
import { invariant } from '#/utils/invariant';

export function getMainChartActiveLayer(data: MainChartData) {
  invariant(data, 'chart data is required to get active layer');

  if (data.barChart?.active) {
    return 'submissions';
  }

  return 'estimatedRange';
}
